import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { styled } from '@linaria/react';
import { AccommodationView } from 'components/Accommodation/AccommodationView';
import { useGetHotelDetails } from 'components/Accommodation/HotelDetailsOverlay/Desktop/useGetHotelDetails';
import { RoundShareButton } from 'components/Accommodation/ShareButton';
import { ShareComponent, ShareType } from 'components/Accommodation/ShareButton/constants';
import { usePriceWatchMobileAppBottomSheet } from 'components/PriceWatch/hooks/usePriceWatchMobileAppBottomSheet';
import { useCache } from 'hooks/useCache';
import { getHotelDetailsOverlayInfo } from 'modules/overlay/selectors';
import { hideOverlay } from 'modules/overlay/slice';
import { Hotel } from 'modules/sapiSearch/slice';
import { getListOfValues } from 'modules/search/selectors';
import { getSearchBoxValues } from 'modules/searchBox/selectors';
import { toggle } from 'opticks';
import { Button } from '@daedalus/atlas/Button';
import { Icon } from '@daedalus/atlas/Icon';
import { trackEvent } from '@daedalus/core/src/analytics/modules/actions';
import { Action, Category, Entity, Team } from '@daedalus/core/src/analytics/types/Events';
import { isReactNativeWebView } from '@daedalus/core/src/native';
import { AccommodationFloatingHeader } from '@daedalus/shared/src/accommodation/AccommodationFloatingHeader';
import { ContentHotel } from '@findhotel/sapi';
import { mergeListOfValues } from '../utils';
const AccommodationBox = /*#__PURE__*/styled('div')({
  name: "AccommodationBox",
  class: "ad1javw",
  propsAsIs: false
});
export const AccommodationOverlayContent = () => {
  const dispatch = useDispatch();
  const {
    checkIn,
    checkOut,
    rooms
  } = useSelector(getSearchBoxValues);
  const {
    hotelId: activeOverlayHotelId
  } = useSelector(getHotelDetailsOverlayInfo);
  // Cache hotel id because value will be empty when overlay is hidden but still animating out
  const hotelId = useCache(activeOverlayHotelId);
  // Added as part of sapi4eva-hotel-descriptions
  const hotel = useGetHotelDetails(hotelId);
  const {
    shouldOpenPriceWatchMobileBottomSheetOnApToSrpScenario
  } = usePriceWatchMobileAppBottomSheet();
  const listOfValues = useSelector(getListOfValues);
  const contentHotel = useMemo(() => hotel ? mergeListOfValues(hotel as Hotel, listOfValues) : undefined, [hotel, listOfValues]);
  const shareUrlParams = {
    hotelId: hotel?.objectID,
    checkIn,
    checkOut,
    rooms,
    component: ShareComponent.HotelDetails
  };
  const goBack = () => {
    dispatch(hideOverlay());
    isReactNativeWebView() && shouldOpenPriceWatchMobileBottomSheetOnApToSrpScenario();
    dispatch(trackEvent({
      category: Category.User,
      entity: Entity.HotelDetailsBackButton,
      action: Action.Clicked,
      team: Team.Select
    }));
  };
  return <AccommodationBox>
      <AccommodationFloatingHeader rightSlot={<>
            <RoundShareButton shareParams={shareUrlParams} component={ShareComponent.HotelDetails} shareType={ShareType.ShareLink} />
          </>} leftSlot={<Button variant="secondary" isRounded isFloating iconStart={<Icon name="ChevronLeft" />} dataId="BackButton" onClick={goBack} size="lg" />} />
      <AccommodationView hotelId={hotelId} hotel={toggle('sapi4eva-hotel-descriptions', contentHotel, hotel) as ContentHotel} />
    </AccommodationBox>;
};
export default AccommodationOverlayContent;

require("./AccommodationOverlayContent.wyw-in-js.css!=!../../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./AccommodationOverlayContent.tsx");